<template>
    <div class="table-body">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-table-body'
    }
</script>

<style lang="scss">
    .table-body {
        display: table-row-group;
    }
</style>


// WEBPACK FOOTER //
// src/components/table/Body.vue